import { Switch } from "./switch.js";
import { SwitchStyles, SwitchTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Switch component.
 *
 * @public
 */
export const definition = Switch.compose({
    name: `${DesignSystem.prefix}-switch`,
    template: SwitchTemplate,
    styles: SwitchStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=switch.definition.js.map